export const collapsibleSidebarPaddingRight = {
  base: 'calc(var(--chakra-space-6) - (var(--page-sidebar-width) - 100%))',
  b1281: `calc(var(--chakra-space-6) - (300px - 100%))`,
};
